export default __webpack_public_path__ + "static/media/dif03.5ab187c0.svg";